import { css } from '@emotion/react';
import { useTranslation } from '~/_shared/utils/hooks';

const centerStyle = css({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

const wrapperStyle = css(centerStyle, {
  gap: 18,
  padding: '38px 0',
});

export const MapListingNoSharedMapsComponent = () => {
  const [t] = useTranslation();

  return (
    <div css={wrapperStyle}>
      {t('mapListing.noSharedMapsWithMe.description')}
    </div>
  );
};
